import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';

@Injectable()
export class TokenEncrption{

    generateUniqueToken() {
    const timestamp = new Date().getTime();
    const randomString = Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${randomString}`;
    }

    getencryptedToken() {
        // const secretKey = 'nzflbmccyFroFIkV'; 
        // const tokenNeedToEncrypt = 'ebb2ee5e53ad458ca8f8f61012f37657';
        // const encrypted = CryptoJS.AES.encrypt(tokenNeedToEncrypt, CryptoJS.enc.Utf8.parse(secretKey), {
        //   mode: CryptoJS.mode.ECB,
        //   padding: CryptoJS.pad.Pkcs7
        // }).toString();
        // return encrypted;
        
        return 'sMZgQIqq/u+/svjymuv3q5IjT6urgLw/uiCsVUzREJ8peQLN6fIFZ/XOX5qUTDZN';
        
      }
}


// WEBPACK FOOTER //
// ./src/app/services/encryption-File.service.ts